import { GeoPoint, Timestamp } from '../database/tasks'

export const toGeoPoint = (value) => {
    if (value && value !== '' && value.includes(',')) {
        let [lat, long] = value.split(',')
        return new GeoPoint(parseFloat(lat.trim()), parseFloat(long.trim()))
    } else {
        return null
    }
}

export const toTimestamp = (value) => {
    if (value && value !== '') {
        return Timestamp.fromDate(value)
    } else {
        return null
    }
}
